// extracted by mini-css-extract-plugin
export default {"modalOverlay":"rE-z","modalContent":"sE-z","header":"tE-z","close":"uE-z"};